import Vue from 'vue';
import { MutationTree } from 'vuex';
import { CourseState } from './state';
import { ChimeraCourseInfo } from '@/models/chimera/ChimeraCourseModel';
import { SupportMaterialFoldersInfo } from '@/models/chimera/ChimeraCourseMaterialsModel';

const mutations: MutationTree<CourseState> = {
  SET_CHIMERA_USER_COURSES(state, chimeraCourses: ChimeraCourseInfo[]) {
    state.chimeraCourses = chimeraCourses;
  },
  SET_CHIMERA_USER_EXPIRED_COURSES(state, chimeraExpiredCourses: ChimeraCourseInfo[]) {
    state.expiredChimeraCourses = chimeraExpiredCourses;
  },
  SET_CHIMERA_COURSE_MATERIAL_FILES(
    state,
    payload: { chimeraCourseMaterials: SupportMaterialFoldersInfo; chimeraCourseId: string },
  ) {
    const { chimeraCourseMaterials, chimeraCourseId } = payload;
    Vue.set(state.chimeraCoursesMaterials, chimeraCourseId, chimeraCourseMaterials);
  },

  SWITCH_CHIMERA_CURRENT_COURSE(state, courseId: string) {
    const currentCourse = state.chimeraCourses?.find(
      // eslint-disable-next-line no-underscore-dangle
      (chimeraCourse) => chimeraCourse._id === courseId,
    );
    state.currentChimeraCourse = currentCourse || null;
  },
};

export default mutations;
